<template>
  <div
    :meta-error="metaError"
    :class="['input-component w-full relative', extraClass, isActive && 'is-active', error && 'is-error', !!value && 'is-filled']"
  >
    <label
      :class="[
        'text-xs font-bold cursor-text mb-2 flex',
        error && 'text-4y-brick-red',
        !error && isActive && 'text-4y-sky-blue'
      ]"
      :for="computedId"
    >
      {{ label }}
    </label>

    <div class="input relative">
      <input
        :id="computedId"
        v-model="inputValue"
        :placeholder="placeholder"
        :name="name"
        :autocomplete="autocomplete"
        :disabled="disabled"
        type="text"
        class="w-full h-12.5 text-base px-6 appearance-none  outline-none"
        :class="[
          inputClass,
          (isActive || !!value) ? 'font-bold' : 'font-light',
          (!isActive && !error) && 'border-4y-gray-300',
          isActive && 'text-4y-sky-blue border-4y-sky-blue',
          (error && !isActive) && 'border-4y-brick-red',
          (error || isActive) && 'border-2',
          !error && !isActive && 'border',
          isActive && 'placeholder-transparent',
          !isActive && 'placeholder-4y-brownish ',
        ]"
        @focus="onFocus"
        @blur="onBlur"
        @paste="onPaste"
        @change="onChange"
      >
      <span
        v-if="optional"
        class="optional absolute right-0 bottom-0 top-0 flex items-center mr-3 text-xs text-gray-600 leading-none"
      >
        {{ tr('components.flightVoucher.form.optional') }}
      </span>
    </div>

    <p v-if="error" class="mt-2 text-4y-brick-red font-bold">
      {{ error }}
    </p>
  </div>
</template>

<script>
import TextInput from '~components/shared/text-input'

export default TextInput.extend({})
</script>

<style lang="scss" scoped>
  .input-component {
    label {
      @apply opacity-0 pointer-events-none;
    }

    &.label-visible-always {
      label {
        @apply opacity-100;
      }
    }

    &.is-filled {
      label {
        @apply opacity-100;
      }
    }

    &.is-active {
      label {
        @apply opacity-100;
      }

      .input {
        &::before {
          display: none;
        }
      }
    }

    &.is-error {
    }
  }

  .is-optional {
    .input-component {
      input {
        padding-right: 75px; /* let's assume that word "optional" has that width in all translations */
      }
    }
  }
</style>
